import { useEffect, useState } from "react";
import axios, { apiBaseUrl } from "../../api/axios";
import ResponsiveTable from "../../components/ResponsiveTable";
import { EyeIcon, PencilIcon, TrashIcon, CurrencyDollarIcon } from "@heroicons/react/24/outline";
import ExportButtons from "../../components/ExportButtons";
import { useNavigate } from "react-router-dom";
import moment from "moment"

export default function CategoryList() {
    const navigate = useNavigate();
    const [expensesList, setExpensesList] = useState([])
    const getCategoryData = () => {
        axios.get("/expenses/expense-categories").then((res) => {
            setExpensesList(res.data);
        });
    }
    useEffect(() => {
        getCategoryData()
    }, []);

    const actions = [
        { label: 'Edit', value: 'edit', icon: <PencilIcon className="w-4 h-4 inline" /> },
        { divider: true },
        { label: 'Delete', value: 'delete', icon: <TrashIcon className="w-4 h-4 inline text-red-600" /> },
    ];
    const handleActionClick = (action, row) => {
        switch (action) {
            case "edit":
                navigate(`/category/edit/${row.id}`);
                break;
            case "delete":
                if (window.confirm("Are you sure you want to delete this sale?")) {
                    axios.delete(`/expenses/expense-categories/${row.id}`).then(() => {
                        getCategoryData()
                    });
                }
                break;
            default:
                break;
        }
    };
    const handleDownload = (type) => {
        const url = `${apiBaseUrl}/purchases/export/${type}`;
        window.open(url, "_blank");
    };
    const columns = [
        { header: "SL", accessor: "sl", render: (v, row, i) => i + 1 },
        {
            header: "Created Date", accessor: "expense_date",
            render: (value, row) => <span>{moment(value).format("DD/MM/YYYY")}</span>
        },
        { header: "Category Name", accessor: "name" },
        { header: "Description", accessor: "description" },
    ];

    return (
        <div className="p-4 max-w-6xl mx-auto text-sm bg-white rounded-md">
            <div className="w-full">
                <ExportButtons title="Category List" onDownload={handleDownload} />
                <ResponsiveTable
                    columns={columns}
                    data={expensesList}
                    showActions
                    actionButtons={actions}
                    onActionClick={handleActionClick}
                />
            </div>
        </div>
    );
}